<script>
  export let timeOff = 0;
  export let timeOn = 0;
  export let rounds = 0;
  export let totalTime = 0;
  export let sounds = false;

  import { onMount, createEventDispatcher } from 'svelte';
	import { speakRound, speakBreak, speakComplete } from './announcer';
  import VisualTimer from './components/VisualTimer.svelte';
  import { Timer, elapsedTime, currentTime, currentStep, completedSteps } from './Timer';
  import Screen from './layout/Screen.svelte';
  import Time from './components/Time.svelte';
  import Button from './components/Button.svelte';
  import Row from './layout/Row.svelte';
  import Flexer from './layout/Flexer.svelte';
  import Bottom from './layout/Bottom.svelte';
  import Section from './layout/Section.svelte';
  import Text from './components/Text.svelte';

  const dispatch = createEventDispatcher();

	let timer = null;
	let steps = [];

  onMount(() => {
    startTimer();

    return () => {
      timer.reset();
      timer = null;
    };
  });

	function resetTimer() {
    timer.reset();
    dispatch('reset');
	}

	function pauseTimer() {
		timer.pause();
	}

  function startTimer() {
    if (!timer) {
      timer = new Timer(rounds, timeOn, timeOff);
      console.log('Sounds: ', sounds)
      if (sounds) {
        timer.setAnnouncer(speakRound, speakBreak, speakComplete);
      }
    }
		timer.start();
	}
</script>

<Screen state={$currentStep.type}>
{#if timer}
  <Flexer>
    <Section>
      <Row centered>
        <Time total={$currentStep.duration} elapsed={$currentTime} color="white" />
      </Row>
    </Section>

    <Section>
      <VisualTimer timeOn={timeOn} timeOff={timeOff} completed={$completedSteps} steps={timer.steps} isRunning={timer.isRunning} />
    </Section>
    <Row centered>
      <Text centered>Time remaining: <Time total={totalTime} size="small" elapsed={$elapsedTime} /></Text>
    </Row>
  </Flexer>
  <Bottom>
    <Row centered>
      <Button class="mr-1" fullWidth on:click={pauseTimer}>pause</Button>
      <Button fullWidth on:click={resetTimer}>reset</Button>
    </Row>
  </Bottom>
{/if}
</Screen>
